<template>
  <div class="info-box-wrapper">
    <InfoBox :text="$t('message.apple.info1')" />
  </div>
</template>

<script>
import InfoBox from "@/components/ui/InfoBox.vue";

export default {
  name: "AppleMapsAccountInfoBoxes",
  components: {
    InfoBox
  }
};
</script>
<style lang="scss" scoped>
.info-box-wrapper {
  display: flex;
  flex-direction: column;
  gap: $spacing;
}
</style>
